import React from 'react'
import firebase from './../Firestore'

import Precio from './Precio';
import Adicionales from './Adicionales';
import Cantidad from './Cantidad';
import AgregarCarrito from './AgregarCarrito';


class Producto extends React.Component {
  constructor(props) {
    super(props);
    this.onPrecioSeleccionado = this.onPrecioSeleccionado.bind(this);
    this.onCantidadSeleccionada = this.onCantidadSeleccionada.bind(this);
    this.onAdicionalesSeleccionado = this.onAdicionalesSeleccionado.bind(this);
    this.state = {
      producto: [],
      producto2: [],
      productoSeleccionado: this.props.productoId,
      producto2Seleccionado: this.props.producto2Id,
      tamanoPrecioSeleccionado: {},
      adicionalesSeleccionados: [],
      cantidadSeleccionada: 1,
      AdicionalNombrePrecioSeleccionado: []
     };
  }

  onPrecioSeleccionado(precioFinal, tamano){
    // precioSeleccionado, si es mas de uno el tamano: ej chica $120
    let tamanoPrecioSeleccionado = {"tamano": tamano, "precio": precioFinal[tamano]};
    this.setState({ tamanoPrecioSeleccionado: tamanoPrecioSeleccionado });
  }

  onCantidadSeleccionada(cantidad){
    //let cantidadSeleccionada = {"cantidad": cantidad};
    this.setState({ cantidadSeleccionada: cantidad });
  }

  onAdicionalesSeleccionado(adicionalesSeleccionados, AdicionalNombrePrecioSeleccionado){
      this.setState({ adicionalesSeleccionados: adicionalesSeleccionados,
        AdicionalNombrePrecioSeleccionado: AdicionalNombrePrecioSeleccionado
       })
  }



  componentDidUpdate(prevProps, prevState){
    // console.log("didupdate 1")
    // if(this.state.productoSeleccionado !== prevState.productoSeleccionado){
    //   this.onCantidadSeleccionada(1)
    //   //this.setState({cantidadSeleccionada: 1})
    //   console.log("didupdate 2")
    // }

    var db = firebase.firestore();
    //console.log("props catid", this.props.categoriaId)
    if (this.props.productoId !== prevProps.productoId) {

      db.collection("producto").doc(this.props.productoId).get().then((doc) => {
            //console.log("vuelta");
            this.setState(
              {
                producto:
                   {
                    "nombre": doc.data().nombre,
                    "descripcion": doc.data().descripcion,
                    "id": doc.id,
                    "imagen": doc.data().imagen,
                    "seFracciona": doc.data().seFracciona,
                    "precio": doc.data().precio,
                    "categoriaId": doc.data().categoriaID
                  }

              }
            );
            this.setState({productoSeleccionado: this.state.producto.id});
      });
        //console.log("prod did update", this.state.producto)
    }

    if(this.props.producto2Id !== 0 && (this.props.producto2Id !== prevProps.producto2Id)){

      db.collection("producto").doc(this.props.producto2Id).get().then((doc) => {
            //console.log("vuelta");
            this.setState(
              {
                producto2:
                   {
                    "nombre": doc.data().nombre,
                    "descripcion": doc.data().descripcion,
                    "id": doc.id,
                    "imagen": doc.data().imagen,
                    "precio": doc.data().precio
                  }

              }
            );
            this.setState({producto2Seleccionado: this.state.producto2.id});
      });

    }
      if (this.props.producto2Id !== prevProps.producto2Id && this.props.producto2Id === 0 ) {
        this.setState({producto2: {},
          producto2Seleccionado: 0
        })
    }
  }

    onChange(event) {
      //this.setState({ productoSeleccionado: event.target.value })
    }


  render() {

    let imagenProducto2 = "";
    let classImagenes = "col";
    let descripcion;

    if (this.props.producto2Id !== 0){
      //classImagenes = "side-crop col";

      //let imgSrc = "../../img/productos/"+ this.state.producto2.imagen;
      imagenProducto2 = (
        <div className="img-fluid col derecha">
          <img src={this.state.producto2.imagen} className="img-fluid float-right my-auto rounded" alt=""></img>
        </div>
      );

      descripcion = (
        <div className="pl-2">
        <p><span className="badge badge-secondary">Mitad</span> <strong>{this.state.producto.nombre}</strong>: <em>{this.state.producto.descripcion}</em> </p>
        <p><span className="badge badge-secondary">Mitad</span> <strong>{this.state.producto2.nombre}</strong>: <em>{this.state.producto2.descripcion}</em> </p>
        </div>
      );


    } else {
      descripcion = (
        <p className="mx-2"><small><strong>{this.state.producto.nombre}</strong>: <em>{this.state.producto.descripcion}</em></small></p>
      );
    }

    //let imgSrc = "../../img/productos/"+ this.state.producto.imagen;

    return (

      <div className="Producto">
        <AgregarCarrito id="AgregarCarrito" uid={this.props.uid} diseno={this.props.diseno} productoSeleccionado={this.state.productoSeleccionado} producto2Seleccionado={this.state.producto2Seleccionado} cantidadSeleccionada={this.state.cantidadSeleccionada} tamanoPrecioSeleccionado={this.state.tamanoPrecioSeleccionado} adicionalesSeleccionados={this.state.adicionalesSeleccionados}/>
        <Cantidad producto={this.state.tamanoPrecioSeleccionado} adicionales={this.state.AdicionalNombrePrecioSeleccionado} cantidadSeleccionada={this.onCantidadSeleccionada} esMitad={this.state.producto2Seleccionado !== 0 ? true : false}/>
        <Precio className="mt-2" producto1={this.state.producto.precio} producto2={this.state.producto2.precio} precioSeleccionado={this.onPrecioSeleccionado} />
      <div className="Descripcion">{descripcion}</div>
        <div className="row text-center w-75 mx-auto mb-2">
            <div className={classImagenes}>
              <img src={this.state.producto.imagen} className="img-fluid my-auto rounded" alt=""></img>
            </div>
            {imagenProducto2}
        </div>



        <Adicionales categoriaId={this.state.producto.categoriaId} adicionalesSeleccionados={this.onAdicionalesSeleccionado} />



    </div>
    )
  }
}

export default Producto
